module.exports = __webpack_public_path__ + "fonts/Inter-400-vietnamese29.74fe938.woff2";